import { Panel } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import FormatComment, {
    type Comment,
} from '@components/_atoms/Formaters/FormatComment';

export interface CommentsPanelProps {
    comments: Comment[];
}

export function CommentsPanel({ comments }: CommentsPanelProps): ReactNode {
    return (
        <Panel header="Comments">
            {comments.length > 0
                ? comments.map((comment) => (
                      <FormatComment
                          key={comment.createTime}
                          comment={comment}
                      />
                  ))
                : 'No comments available'}
        </Panel>
    );
}
